import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAppTranslation } from "../TranslationContext";
import s from "./Login.module.css";


export const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useAppTranslation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const extractError = (errObj) => {
      if (!errObj) return t('authError') || 'Ошибка авторизации';
      const first = errObj.non_field_errors?.[0]
        || errObj.detail
        || errObj.email?.[0]
        || errObj.username?.[0]
        || errObj.login?.[0]
        || errObj.password?.[0]
        || errObj.message;
      return typeof first === 'string' ? first : (t('authError') || 'Неверный логин или пароль');
    };

    const candidates = [];
    if (email.trim()) candidates.push({ email: email.trim(), password });
    if (username.trim()) candidates.push({ username: username.trim(), password });
    const loginValue = (username || email).trim();
    if (loginValue) candidates.push({ login: loginValue, password });

    let token = null;
    let lastError = null;

    for (const payload of candidates) {
      try {
        const res = await fetch('https://api.eduskill.uz/api/v1/dj-rest-auth/login/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok) {
          lastError = extractError(data);
          continue;
        }

        token = data?.key;
        if (!token) { lastError = t('tokenError') || 'Токен не получен'; continue; }
        break;
      } catch {
        lastError = t('serverError') || 'Сервер не отвечает. Попробуйте позже.';
      }
    }

    if (!token) {
      setError(lastError || (t('wrongCredentials') || 'Неверный логин или пароль'));
      setLoading(false);
      return;
    }

    try {
      const profileRes = await fetch('https://api.eduskill.uz/api/v1/dj-rest-auth/user/', {
        headers: { 'Authorization': 'Token ' + token, 'Accept': 'application/json' },
      });

      const user = await profileRes.json();
      if (!profileRes.ok) {
        setError(extractError(user) || (t('profileError') || 'Не удалось получить профиль'));
        setLoading(false);
        return;
      }

      const userWithId = { ...user, id: user.pk };
      delete userWithId.pk;

      login({ token, user: userWithId });
      localStorage.setItem('token', token);
      navigate('/dashboard');
    } catch {
      setError(t('serverError') || 'Сервер не отвечает. Попробуйте позже.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={s.wrapper}>
          <div className={s.loginBox}>
            <h2 className={s.loginBox__title}>{t('login')}</h2>

            <div className={s.inputGroup}>
              <div className={s.inputWrapper}>
                <label className={s.label}>{t('Username')}</label>
                <input
                  type="text"
                  value={username}
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              <div className={s.inputWrapper}>
                <label className={s.label}>{t('Email')}</label>
                <input
                  type="email"
                  value={email}
                  required
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className={s.inputWrapper}>
                <label className={s.label}>{t('Password')}</label>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  required
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className={s.eyeButton}
                  onClick={() => setShowPassword(v => !v)}
                  aria-label={showPassword ? (t('hidePassword') || 'Скрыть пароль') : (t('showPassword') || 'Показать пароль')}
                >
                  {showPassword ? '🙈' : '👁'}
                </button>
              </div>
            </div>

            {error && (
              <p style={{ color: 'crimson', fontSize: 14, marginBottom: 12, textAlign: 'center' }}>
                {error}
              </p>
            )}

            <div className={s.buttonGroup}>
              <button type='submit' className={s.loginBtn} disabled={loading}>
                {loading ? (t('loading') || '...') : t('login')}
              </button>
              <Link to="/register" className={s.registerBtn}>{t('createProfile')}</Link>
            </div>

          </div>
        </div>
      </form>
    </>
  );
};
